﻿import { convertToDate, convertToDateByFormat } from "../../utils/date";
import { IEditor } from "../interface/editor";
import { ValidatorError } from "../types/validator-error";
import { ValidatorFn } from "../types/validator-fn";
import { ValidatorParam } from "../interface/validator-param";
import { isValidatorDisabled } from "./is-validator-disabled";

export interface dateValidatorParam extends ValidatorParam {
    format?: string;
    min?: Date;
    max?: Date;
}

export function dateValidator(param: dateValidatorParam): ValidatorFn {
    return (editor: IEditor): ValidatorError | null => {
        if (isValidatorDisabled(param, editor)) {
            return null;
        }

        if (editor.value === undefined || editor.value == null || editor.value === '') {
            return null;
        }

        let message='Validate Failed';
        if(param.message) {
            message= param.message;
        }


        let date: Date | null = null;
        try {
            if (param.format) {
                date = convertToDateByFormat(String(editor.value), param.format);
            } else {
                date = convertToDate(editor.value);
            }
        }
        catch {
            return { message: message };
        }

        if (date != null) {
            if ((param.min && date < param.min)
                || (param.max && date > param.max)
            ) {
                return { message: message };
            }
        } else {
            return { message: message };
        }

        return null;
    };
}
